/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_MASTER } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { HeadingListComponent } from './components/heading-list/heading-list.component';
import { HeadingListBusinessService } from './resources/heading-list-business.service';

const routes = [
  createRoute({
    component: HeadingListComponent,
    path: '',
    pathMatch: 'full',
    init: HeadingListBusinessService,
    leave: true,
    auth: {
      applicationView: [APPLICATION_VIEW_MASTER],
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupRfqStructureRoutingModule {
}
